export default __webpack_public_path__ + "static/media/usa.7084274d.svg";